import { Tenant } from '@internal/backstage-plugin-kaap';

import { KaapTenant } from './types';

export const serializeTenants = (tenant: Tenant): KaapTenant => {
  return {
    id: tenant.id,
    name: tenant.name,
    clusterId: tenant.clusterId,
    clusterSubscriptionName: tenant.clusterId?.split('/')[0] ?? '',
    clusterName: tenant.getClusterName(),
    ownerId: tenant.ownerObjectId,
    pimEnabled: tenant.pimEnabled,
    pimGroupId: tenant.pimGroupId,
  };
};
